import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/layout/admin';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import { unformatTitle } from '../../utilities/dataFormat';
import ContentPagination from '../../components/fragments/ContentPagination';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  cancelMission,
  getDetailMission,
  pickMission
} from '../../services/detailMission';
import {
  Button,
  Card,
  Divider,
  Flex,
  Grid,
  Group,
  Image,
  Space,
  Text,
  Title
} from '@mantine/core';
import {
  MdAccountTree,
  MdCalendarMonth,
  MdCalendarToday,
  MdCalendarViewDay
} from 'react-icons/md';
import { FiGift } from 'react-icons/fi';
import { TbCircleLetterP } from 'react-icons/tb';
import { showNotification } from '../../utilities/mantineNotification';
import {
  cancelVoucher,
  getDetailRedeem,
  pickVoucher
} from '../../services/detailRedeem';
import { getSharepointCdnFileMedia } from '../../utilities';
import { FaBox } from 'react-icons/fa';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';

function useGetQuery() {
  const { search } = useLocation();
  // history

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ProfileDetailRedeem = (props) => {
  const params = useParams<any>();
  let query = useGetQuery();
  let history = useHistory();
  const [modalDialog, setModalDialog] = useState(false);

  const fetchedDetailRedeem = useQuery({
    queryKey: ['getDetailRedeem'],
    queryFn: () =>
      getDetailRedeem({
        id: params.id.toString(),
        idTransaksi: query.get('type').toString() || ''
      })
  });

  const openConfirmationModal = () => {
    setModalDialog(true);
  };

  const handlePickVoucher = () => {
    const payload = {
      inventoryRewardID: params.id,
      inventoryRewardPickedID: null,
      status: 'Diambil'
    };
    pickVch.mutate(payload);
  };

  const handleCancelVoucher = () => {
    const payload = {
      inventoryRewardPickedID: query.get('type').toString()
    };
    cancelVch.mutate(payload);
  };

  const pickVch = useMutation({
    mutationFn: pickVoucher,
    onSuccess: () => {
      fetchedDetailRedeem.refetch();
      showNotification({
        type: 'success',
        title: 'Success Redeem'
      });
      // go to ../
      history.goBack();
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const cancelVch = useMutation({
    mutationFn: cancelVoucher,
    onSuccess: () => {
      fetchedDetailRedeem.refetch();
      showNotification({
        type: 'success',
        title: 'Success Cancel Redeem'
      });
      history.goBack();
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle={'Detail Redeem'}
        itemList={[
          {
            title: 'My Profile',
            href: '/profile'
          },
          {
            title: 'Detail Redeem',
            href: '#'
          }
        ]}
      />
      <div>
        <ModalConfirmation
          isVisible={modalDialog}
          type={''}
          onCancel={() => {
            setModalDialog(false);
          }}
          onConfirm={() => {
            handlePickVoucher();
          }}
        />
        <Grid>
          <Grid.Col span={{ base: 12, md: 8 }}>
            <Card>
              <Flex justify={'space-between'}>
                <Group justify="space-between">
                  <Text fw={800} size="xl">
                    {fetchedDetailRedeem.data?.data?.data[0]?.inventoryName}
                  </Text>
                </Group>
                <Image
                  src={getSharepointCdnFileMedia(
                    fetchedDetailRedeem.data?.data?.data[0]?.rewardImage
                  )}
                  w={80}
                  radius="full"
                  style={{ cursor: 'pointer' }}
                />
              </Flex>

              <Divider my="lg" />
              {fetchedDetailRedeem.data?.data?.data[0]?.description
                .split('\n')
                .map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))}
            </Card>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Card>
              <Text fw="700">Voucher Detail</Text>
              <Divider my="lg" />
              <Flex align="center">
                <MdCalendarMonth size={20} />
                <Space w="sm" />
                <Text size="sm" fw="700">
                  Valid Until
                </Text>
              </Flex>
              <Space mt="xs" />
              <Text>
                {convertDate(fetchedDetailRedeem.data?.data?.data[0]?.endDate)}
              </Text>
              <Space mt="xs" />
              <Flex align="center">
                <TbCircleLetterP size={20} color="orange" />
                <Space w="sm" />
                <Text size="sm" fw="700">
                  {fetchedDetailRedeem.data?.data?.data[0]?.redeemPoint} Point
                </Text>
              </Flex>
              <Space mt="xs" />
              <Flex align="center">
                <FaBox size={20} color="purple" />
                <Space w="sm" />
                <Text size="sm" fw="700">
                  {fetchedDetailRedeem.data?.data?.data[0]?.availableStock} left
                </Text>
              </Flex>
              {query.get('type') &&
              fetchedDetailRedeem.data?.data?.data[0]?.statusVoucher !==
                'Diambil' &&
              fetchedDetailRedeem.data?.data?.data[0]?.statusVoucher !==
                'Kosong' ? (
                <div>
                  <Button
                    onClick={() => {}}
                    color={
                      fetchedDetailRedeem.data?.data?.data[0]?.statusVoucher ==
                      'Approved'
                        ? 'green'
                        : fetchedDetailRedeem.data?.data?.data[0]
                            ?.statusVoucher == 'Rejected'
                        ? 'red'
                        : 'orange'
                    }
                    fullWidth
                    mt="md"
                    radius="md"
                  >
                    {fetchedDetailRedeem.data?.data?.data[0]?.statusVoucher ==
                    'Approved'
                      ? 'Approved'
                      : fetchedDetailRedeem.data?.data?.data[0]
                          ?.statusVoucher == 'Rejected'
                      ? 'Rejected'
                      : 'Waiting for Approval'}
                  </Button>
                  <hr
                    style={{
                      marginTop: '20px',
                      height: '4px',
                      backgroundColor: 'gray',
                      marginBottom: '5px'
                    }}
                  ></hr>
                  <Text
                    style={{
                      color: 'black',
                      fontWeight: 'bold',
                      marginTop: '15px'
                    }}
                  >
                    Notes:
                  </Text>
                  <Text style={{ whiteSpace: 'pre-line' }}>
                    {fetchedDetailRedeem.data?.data?.data[0]?.notes ||
                      'No notes available for this voucher.'}
                  </Text>
                  <Text
                    style={{
                      color: 'black',
                      fontWeight: 'bold',
                      marginTop: '15px'
                    }}
                  >
                    Updated at:
                  </Text>
                  <Text>
                    {convertDate(
                      fetchedDetailRedeem.data?.data?.data[0]?.dateUp
                    )}
                  </Text>
                </div>
              ) : (
                <Button
                  onClick={() => {
                    fetchedDetailRedeem.data?.data?.data[0]?.isPicked ==
                    'Diambil'
                      ? handleCancelVoucher()
                      : parseInt(
                          fetchedDetailRedeem.data?.data?.data[0]?.point
                        ) >
                        parseInt(
                          fetchedDetailRedeem.data?.data?.data[0]?.redeemPoint
                        )
                      ? fetchedDetailRedeem.data?.data?.data[0]?.maxRedeem ===
                        fetchedDetailRedeem.data?.data?.data[0]?.totalRedeemed
                        ? showNotification({
                            type: 'error',
                            title: 'Max Redeem Reached',
                            message:
                              'You already redeem the maximum redeem for this voucher. Please try another voucher.'
                          })
                        : fetchedDetailRedeem.data?.data?.data[0]
                            ?.availableStock === 0
                        ? showNotification({
                            type: 'error',
                            title: 'Out of Stock',
                            message:
                              'This voucher is out of stock. Please try another voucher.'
                          })
                        : openConfirmationModal()
                      : showNotification({
                          type: 'error',
                          title: 'Not Enough Point',
                          message:
                            'You dont have enough point to redeem this voucher. Please collect more point.'
                        });
                  }}
                  color={
                    fetchedDetailRedeem.data?.data?.data[0]?.isPicked ==
                    'Diambil'
                      ? 'orange'
                      : parseInt(
                          fetchedDetailRedeem.data?.data?.data[0]?.point
                        ) >
                        parseInt(
                          fetchedDetailRedeem.data?.data?.data[0]?.redeemPoint
                        )
                      ? fetchedDetailRedeem.data?.data?.data[0]?.maxRedeem ===
                        fetchedDetailRedeem.data?.data?.data[0]?.totalRedeemed
                        ? 'gray'
                        : fetchedDetailRedeem.data?.data?.data[0]
                            ?.availableStock === 0
                        ? 'gray'
                        : '#7B2183'
                      : 'gray'
                  }
                  fullWidth
                  mt="md"
                  radius="md"
                >
                  {fetchedDetailRedeem.data?.data?.data[0]?.isPicked ==
                  'Diambil'
                    ? 'Cancel Redeem'
                    : parseInt(fetchedDetailRedeem.data?.data?.data[0]?.point) >
                      parseInt(
                        fetchedDetailRedeem.data?.data?.data[0]?.redeemPoint
                      )
                    ? fetchedDetailRedeem.data?.data?.data[0]?.maxRedeem ===
                      fetchedDetailRedeem.data?.data?.data[0]?.totalRedeemed
                      ? `You already redeem ${fetchedDetailRedeem.data?.data?.data[0]?.maxRedeem} times!`
                      : fetchedDetailRedeem.data?.data?.data[0]
                          ?.availableStock === 0
                      ? 'Stock is Empty'
                      : 'Redeem Voucher'
                    : 'Not Enough Point'}
                </Button>
              )}
            </Card>
          </Grid.Col>
        </Grid>
      </div>
    </AdminLayout>
  );
};

// function to convert to date (23 November 2023)
const convertDate = (date: string) => {
  const newDate = new Date(date);
  return newDate.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  });
};

export default ProfileDetailRedeem;
